import { render, staticRenderFns } from "./limitCardGroup.vue?vue&type=template&id=3c9afe44&scoped=true&"
import script from "./limitCardGroup.vue?vue&type=script&lang=js&"
export * from "./limitCardGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9afe44",
  null
  
)

export default component.exports